import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';

//NOTE: try to not use these values too much, as they are read from server and may change
var ACTIVITY_TYPES = {
    STEPS: 'STEPS',
    SLEEP: 'SLEEP',
    FLOORS: 'FLOORS',
    RUNNING: 'RUNNING',
    CYCLING: 'CYCLING',
    LAP_SWIMMING: 'LAP_SWIMMING',
    OPEN_WATER_SWIMMING: 'OPEN_WATER_SWIMMING'
};
//NOTE: try to not use these values too much, as they are read from server and may change
var ACTIVITY_FIELDS = {
    AVG_SPEED: 'AVG_SPEED',
    VO2_MAX_VALUE: 'VO2_MAX_VALUE',
    AVG_POWER: 'AVG_POWER',
    WEEKLY_AVG_DISTANCE: 'WEEKLY_AVG_DISTANCE',
    WEEKLY_AVG_DURATION: 'WEEKLY_AVG_DURATION',
    STEPS: 'STEPS',
    SLEEP: 'SLEEP',
    FLOORS: 'FLOORS',
    COUNT: 'COUNT'
};
//NOTE: try to not use these values too much, as they are read from server and may change
var UNITS = {
    MINUTES_PER_MILE: 'MINUTES_PER_MILE',
    MINUTES_PER_KILOMETER: 'MINUTES_PER_KILOMETER',
    MILES_PER_HOUR: 'MILES_PER_HOUR',
    KILOMETERS_PER_HOUR: 'KILOMETERS_PER_HOUR',
    MINUTES_PER_100_METERS: 'MINUTES_PER_100_METERS',
    MINUTES_PER_100_YARDS: 'MINUTES_PER_100_YARDS',
    MILE: 'MILE',
    KILOMETER: 'KILOMETER',
    METER: 'METER',
    YARD: 'YARD',
    HOUR: 'HOUR',
    WATT: 'WATT',
    NONE: 'NONE'
};

var localeUnitMapper = {
    statute_us: 'STATUTE',
    statute_uk: 'STATUTE',
    metric: 'METRIC'
};

var DemoCompareInsight = Backbone.Model.extend({
    backend: 'insights',

    url: function() {
        if (_.isString(this.age) && this.age.indexOf('+') !== -1) {
            this.age = this.age.slice(0, this.age.indexOf('+'));
        }

        var lang = Localizer.getLocale();
        var url =
            '/gcs-insights/api/demographics/compare?' +
            'gender=' +
            this.gender +
            '&age=' +
            this.age +
            '&type=' +
            this.activityType +
            '&field=' +
            this.activityField +
            '&year=' +
            this.year +
            '&localeUnit=' +
            this.measurementSystem +
            '&lang=' +
            lang;

        if (this.month) {
            url += '&month=' + this.month;
        }

        return url;
    },

    initialize: function(args) {
        args = args || {};
        this.gender = args.gender;
        this.age = args.age;
        this.activityType = args.activityType;
        this.activityField = args.activityField;
        this.year = args.year;
        this.month = args.month;
        this.measurementSystem = localeUnitMapper[args.measurementSystem];
    }
});
DemoCompareInsight.ACTIVITY_TYPES = ACTIVITY_TYPES;
DemoCompareInsight.ACTIVITY_FIELDS = ACTIVITY_FIELDS;
DemoCompareInsight.UNITS = UNITS;
export default DemoCompareInsight;
